import { AlphaAuditClient } from '../alphaAuditClient';
import {
  AuditContext,
  AuditDecision,
  AuditExecutionResult,
} from '../types';
import { defaultAuditHandler } from './defaultHandler';
import { companyDataProspectusHandler } from './companyDataProspectusHandler';

export type AuditHandler = (
  client: AlphaAuditClient,
  decision: Extract<AuditDecision, { auditable: true }>,
  ctx: AuditContext
) => Promise<AuditExecutionResult>;

export const AUDIT_HANDLERS: Record<string, AuditHandler> = {
  default: defaultAuditHandler,
  'company-data-prospectus': companyDataProspectusHandler,
};